import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";

import { Provider } from "react-redux";
import store from "./store/store.js";
import { initSentry } from "./config/sentry.config.js";
import { HelmetProvider } from "react-helmet-async";

initSentry();

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
      <App />
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);
